import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { showHideMenu, ContextualMenu } from 'components/shared/contextualMenu/content';
import { showDeleteTagFromOUConfirmationModal, showEditTagValueModalFromOU } from 'actions/modal.js';
import {
  updateSelectedTagInOU,
  updateAsssignedValuesByTagIdInOU,
  getAvailableTagsByTagIdInOU,
} from 'actions/organisation.js';
import { sortAssignedTags } from 'businessLogic/sorting';
import { Icon } from 'semantic-ui-react';

function ManageTagsContexualMenu(props) {
  const selectedTagObject = useRef(props.selectedTagObject);
  const dispatchRedux = useDispatch();
  const openRemoveTagConfirmationModal = () => {
    let cb = () => {
      dispatchRedux(showDeleteTagFromOUConfirmationModal(true));
    };
    let selectedTagObjectLocal = {
      tagId: props.tag.tagId,
      tagName: props.tag.tagName,
      canAssignTagValue: props.tag.canAssignTagValue,
    };
    dispatchRedux(updateSelectedTagInOU(selectedTagObjectLocal, cb));
  };

  const openEditTagValueModal = () => {
    let cb = () => {
      dispatchRedux(getAvailableTagsByTagIdInOU(props.tag.tagId)).then((dispatch) => {
        let cbForUpdateAssignedValues = () => {
          dispatch(showEditTagValueModalFromOU(true));
        };
        let assignTagValues = [];
        if (!!props.tag) {
          props.tag.tagValues.map((x) => {
            assignTagValues.push({
              tagValueId: x.tagValueId,
              tagValue: x.tagValue,
            });
          });

          let assignTagValuesObject = {};
          if (selectedTagObject.current.tagId === props.tag.tagId) {
            assignTagValuesObject = {
              tagId: selectedTagObject.current.tagId,
              tagName: selectedTagObject.current.tagName,
              canMultiSelect: selectedTagObject.current.canMultiSelect,
              canAssignTagValue: selectedTagObject.current.canAssignTagValue,
              tagValuesHasBeenSaved: props.tag.tagValues,
              tagValuesEdited: assignTagValues,
            };
          }
          dispatch(updateAsssignedValuesByTagIdInOU(assignTagValuesObject, cbForUpdateAssignedValues));
        }
      });
    };

    let selectedTagObjectLocal = {
      tagId: props.tag.tagId,
      tagName: props.tag.tagName,
      canAssignTagValue: props.tag.canAssignTagValue,
    };
    dispatchRedux(updateSelectedTagInOU(selectedTagObjectLocal, cb));
  };
  useEffect(() => {
    selectedTagObject.current = props.selectedTagObject;
  }, [props.selectedTagObject]);

  return (
    <ContextualMenu
      options={[
        {
          title: APP.LANGUAGE.OrganisationalUnitManageTags.EditTagValueFromOrg,
          customAction: false,
          action: () => openEditTagValueModal(),
        },
        {
          title: APP.LANGUAGE.OrganisationalUnitManageTags.RemoveTagFromOrg,
          customAction: false,
          action: () => openRemoveTagConfirmationModal(),
        },
      ]}
    />
  );
}

const OrgUnitManageTagsCenterPanel = ({
  searchTerm,
  onSearchTermInputChange,
  dispatch,
  fetchingTags,
  orgUnit,
  selectedTagObject,
  isOnMobileOrTablet,
}) => {
  const getTagRowMarkup = (tag, isGray) => {
    const tagValues = tag.tagValues
      .map((x) => x.tagValue)
      .sort()
      .join(', ');

    return (
      <div
        className={
          isOnMobileOrTablet
            ? 'row flexible row-hoverable reporting-tag mrlm mrrm'
            : 'row flexible row-hoverable reporting-tag'
        }
        data-opaque={!!isGray}
        key={tag.tagId}
        onClick={(event) => {
          if (tag.canAssignTagValue) {
            showHideMenu(null, '.manage-tags-waiting-area-container', tag.tagId, event.target, event.currentTarget);
          }
        }}
      >
        {/* Column #1 - Tag Name (7 wide for tablet and above / full 16 wide on mobile) */}
        <div className="tablet only computer only six wide column left-column-fixed status-column left-text users-column inline-flex center-flex">
          <div className="pdls max-width pdrs">{tag.tagName}</div>
          <Icon
            name="angle down"
            style={{ minWidth: '20px' }}
            className="relative arrow-down-on-mobile chevron-large-margin-top"
          />
        </div>

        {/* Column #2 - Tag Value - (shown only on tablet and above) */}
        <div className="tablet only computer only ten wide column right-column-fixed left-text users-column inline-flex center-flex pdlnull">
          <div>{tagValues}</div>
        </div>
        <div className="mobile only column max-width pdlnull pdrnull inline-flex space-between">
          <div className="left-text">
            <div>{tag.tagName}</div>
            <div className="text-size-ms secondary-text">{tagValues}</div>
          </div>
          <div className="inline-flex center-with-flex">
            <Icon
              name="angle down"
              style={{ minWidth: '20px' }}
              className="mrrnull relative arrow-down-on-mobile chevron-margin-top"
            />
          </div>
        </div>
        {!!tag.canAssignTagValue ? (
          <ManageTagsContexualMenu
            dispatch={dispatch}
            orgUnit={orgUnit}
            tag={tag}
            selectedTagObject={selectedTagObject}
          />
        ) : (
          ''
        )}
      </div>
    );
  };

  const tableHeaderMarkup = (
    <div className="row flexible  color-organisational-unit-bg pdtnull pdbnull header-row pdlnull">
      {/* Column #1 header */}
      <span className="ui six wide tablet  six wide computer  sixteen wide mobile  column  icon input color-white display-flex">
        <input
          type="text"
          className="ui input color-white borderless color-organisational-unit-bg-highlight max-width pdxs"
          onChange={(e) => onSearchTermInputChange(e)}
          value={searchTerm}
          placeholder={APP.LANGUAGE.OrganisationalUnitManageTags.ColumnHeader1Title}
        />
        <i className="filter icon mrrml" />
      </span>

      {/* Column #2 header */}
      <span className="ui  tablet only  computer only  ten wide column color-white display-flex">
        <div className="color-white max-width pdxs left-text">
          {APP.LANGUAGE.OrganisationalUnitManageTags.ColumnHeader2Title}
        </div>
      </span>
    </div>
  );

  const tagsLoadingMarkup = [{}, {}].map((o, i) => {
    return (
      <div
        className={isOnMobileOrTablet ? 'row flexible row-hoverable mrlm mrrm' : 'row flexible row-hoverable'}
        key={i}
      >
        {i == 0 ? (
          <div className="ui active inverted dimmer ">
            <div className="ui text loader pdtxl mrtl " />
          </div>
        ) : (
          <div className="ui active inverted dimmer " />
        )}

        <div className="seven wide tablet  seven wide computer  sixteen wide mobile  column left-column-fixed status-column left-text users-column">
          <span className="color-gray-bg color-gray ">asdasdasdasdasd</span>
        </div>
        <div className="ui  tablet only  computer only  nine wide column color-white display-flex">
          <span className="color-gray-bg color-gray ">asdasdasdasdasd</span>
        </div>
      </div>
    );
  });

  const noTagsAvailableMarkup = (
    <div className={isOnMobileOrTablet ? 'row flexible row-hoverable mrlm mrrm' : 'row flexible row-hoverable'}>
      <div className="seven wide tablet  seven wide computer sixteen wide mobile">
        <div className="column text-size-ml pdls pdrs no-tags-available-message">
          {APP.LANGUAGE.OrganisationalUnitManageTags.NoTagsAvailable}
        </div>
      </div>
    </div>
  );

  const sortedTags = sortAssignedTags(orgUnit.tags || []);
  let tagsMatchingSearchTerm = sortedTags;
  let tagsNotMatchingSearchTerm = [];

  if (searchTerm && searchTerm.trim().length > 0) {
    // do the filtering
    const searchTermLowerCase = searchTerm.toLowerCase();
    tagsMatchingSearchTerm = [];
    tagsNotMatchingSearchTerm = [];

    sortedTags.forEach((tag) => {
      if (
        tag.tagName.toLowerCase().indexOf(searchTermLowerCase) > -1 ||
        tag.tagValues.some((e) => e.tagValue.toLowerCase().indexOf(searchTermLowerCase) > -1)
      )
        tagsMatchingSearchTerm.push(tag);
      else tagsNotMatchingSearchTerm.push(tag);
    });
  }

  const tagsMatchingSearchTermMarkup = tagsMatchingSearchTerm
    ? tagsMatchingSearchTerm.map((tag) => getTagRowMarkup(tag, false))
    : '';
  const tagsNotMatchingSearchTermMarkup = tagsNotMatchingSearchTerm
    ? tagsNotMatchingSearchTerm.map((tag) => getTagRowMarkup(tag, true))
    : '';

  let tableContentMarkup;
  if (fetchingTags === true) tableContentMarkup = tagsLoadingMarkup;
  else if (sortedTags && sortedTags.length > 0)
    tableContentMarkup = tagsMatchingSearchTermMarkup.concat(tagsNotMatchingSearchTermMarkup);
  else tableContentMarkup = noTagsAvailableMarkup;

  return (
    <span>
      <div className="ui center aligned padded grid">
        {tableHeaderMarkup}
        {tableContentMarkup}
      </div>
    </span>
  );
};

OrgUnitManageTagsCenterPanel.propTypes = {
  searchTerm: PropTypes.string,
  onSearchTermInputChange: PropTypes.func,
  dispatch: PropTypes.func,
  fetchingTags: PropTypes.bool,
  orgUnit: PropTypes.object,
  selectedTagObject: PropTypes.object,
};

export default OrgUnitManageTagsCenterPanel;
